<!-- eslint-disable -->
<template lang="pug">
		.reset-box
				.reset-box__header
						| {{ $i18n.t('auth.auth_forgotPassword_header') }}
				.reset-box__body
						form.reset-box__form(action="javascript://" @submit="resetPassword")
								.reset-box__item
										cs-input(
												:class="{'cs-input--error': errors.has('email')}"
												type="email"
												:placeholder="$i18n.t('auth.auth_forgotPassword_emailPlaceholder')"
												v-model="email"
												v-validate="'required|email'"
												name="email"
												:data-vv-as="$i18n.t('auth.auth_forgotPassword_emailPlaceholder').toLowerCase()"
										)
										help-text(v-show="errors.has('email')" :error="errors.has('email')")
												| {{ errors.first('email')}}
								.reset-box__item
										cs-input(
												:class="{'cs-input--error': errors.has('password')}"
												type="password"
												:placeholder="$i18n.t('auth.auth_resetPassword_newPassword')"
												v-model="password"
												v-validate="'required|min:6|confirmed:password_confirmation'"
												name="password"
												:data-vv-as="$i18n.t('auth.auth_resetPassword_newPassword').toLowerCase()"
										)
										help-text(v-show="errors.has('password')" :error="errors.has('password')")
												| {{ errors.first('password')}}
								.reset-box__item
										cs-input(
												:class="{'cs-input--error': errors.has('password_confirmation')}"
												type="password"
												:placeholder="$i18n.t('auth.auth_resetPassword_passwordConfirm')"
												v-model="password_confirmation"
												v-validate="'required|min:6'"
												name="password_confirmation"
												:data-vv-as="$i18n.t('auth.auth_resetPassword_passwordConfirm').toLowerCase()"
										)
										help-text(v-show="errors.has('password_confirmation')" :error="errors.has('password_confirmation')")
												| {{ errors.first('password_confirmation')}}
								cs-button(
										type="submit"
										color="blue"
										:loading="isLoading"
										:fullWidth="true"
								) {{ $i18n.t('auth.auth_resetPassword_button') }}
						.reset-box__footer
								.reset-box__link-container
										router-link.reset-box__link(:to="{name: 'login'}")
												| {{ $i18n.t('auth.auth_common_auth') }}
</template>

<script>
    /*eslint-disable*/
    import AuthApi from '../../api/auth';
    import HelpText from '../../elements/HelpText.vue';

    export default {
        components: {
            HelpText,
        },
        data() {
            return {
                email: "",
                password: "",
                password_confirmation: "",
                isLoading: false,
            }
        },
        computed: {
            token() {
                return this.$route.params.token;
            }
        },
        methods: {
            resetPassword() {
                if (!this.isLoading) {
                    return this.$validator.validateAll()
                        .then(
                            isValid => this.sendRequest(isValid),
                            error => this.$toasted.error(this.$i18n.t('errors.fill_form'))
                        )
                        .then(
                            response => response
                                ? this.redirect()
                                : this.$toasted.error(this.$i18n.t('errors.fill_form')),
                            error => {
                                this.isLoading = false;
                                this.$toasted.error(this.$i18n.t('errors.password_changing'));
                            }
                        );
                }
                return Promise.resolve()
            },
            sendRequest (isValid) {
                if (isValid) {
                    this.isLoading = true;
                    return AuthApi.restorePassword({
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                        token: this.token
                    })
                }
            },
            redirect () {
                this.isLoading = false;
                this.$toasted.success(this.$i18n.t('auth.auth_resetPassword_newPasswordAccessed'));
                this.$router.push({name: 'login'})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .reset-box {
        margin: 0 auto;
        background-color: $x-color-white;
        @include media($sm) {
            border-radius: 40px;
            max-width: 400px;
        }
        @include media($md) {
            max-width: 600px;
        }
    }

    .reset-box__header {
        font-size: 32px;
        line-height: 38px;
        font-weight: 500;
        text-align: center;
        padding-top: 40px;
    }

    .reset-box__body {
        padding-top: 13px;
    }

    .reset-box__footer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .reset-box__divider {
        border: 0;
        margin: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: calc(100% - 60px);
    }

    .reset-box__link-container {
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .reset-box__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .reset-box__item {
        padding-bottom: 14px;
    }

    .reset-box__form {
        max-width: 260px;
        @include media($md) {
            max-width: 300px;
        }
        margin: 0 auto;
    }
</style>


